
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBase from 'dijit/_WidgetBase';
import { TabContainer, _TabEnabledMixin } from "../_loadingHelpers/Tabbing";
import methodHooks from 'more/mdsMethodHooks';

/**
 * TabManager verwaltet existierende Tabcontainer und deren Tabs
 */
class TabManager extends methodHooks(compose(_WidgetBase)) {
    templateString = "<div></div>";

    createNewTab(config: Tabbing.TabPageDescriptor, activate?: boolean, replaceExisting?: boolean): boolean {
        if (!config ) {
            return false;
        }

        let container: MdsLax<InstanceType<typeof TabContainer>> = null;


        let actualName = config.name;
        if (actualName == "_blank") { // Todo: bessere Typisierung als string | _blank ??
            actualName = (Math.random() * 10000000).toFixed(0);
            config.name = actualName;
        }

        if (config.targetContainerName) {
            container = this.getTabContainerByName(config.targetContainerName);
        } else {
            container = this.getTabContainerOfWidget(config.widget, 9999);
        }
        if (!container) {
            
            return;
        }

        let existingTab = this.getExistingTab(config.name, container.name, activate == true);

        if (existingTab && !replaceExisting) {
            try {
                if (config.groupLabel) (existingTab.widget as MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>>).requestTabRename(config.groupLabel);
                else if (config.label) (existingTab.widget as MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>>).requestTabRename(config.label);
            } catch (ex) {

            }

            return true; // ?? ist es false oder eigentlich doch true?
        }

        if (existingTab && replaceExisting == true) {
            container.destroyPage(config.name);
        };

        container.createTab(config);

        if (activate === true) {
            return container.switchToTab(config.name);
        }

        return true;
    }

    getTabContainers(): Array<MdsLax<InstanceType<typeof TabContainer>>> {
        let result = [];

        for (let key in window.dijit.registry._hash) {
            let widget: MdsLax<InstanceType<typeof _WidgetBase>> = window.dijit.registry._hash[key];

            if (widget instanceof TabContainer) {
                if (!widget._destroyed) {
                    result.push(widget);
                }
            }
            else if (widget["declaredClass"] == "TabContainer") {
                if (!(widget as any)._destroyed) {
                    result.push(widget);
                }
            }
        }

        return result;
    }

    getTabContainerByName(name: string): MdsLax<InstanceType<typeof TabContainer>> {
        let result: MdsLax<InstanceType<typeof TabContainer>> = null;

        let availableContainers = this.getTabContainers();

        for (let container of availableContainers) {
            if (container.name == name) return container;
        }

        return null;
    }

    getTabContainerOfWidget(widget: MdsLax<InstanceType<typeof _WidgetBase>>, maxLevels?: number) {
        return this._getParentTabContainerOfWidget(widget, maxLevels);
    }

    private _getParentTabContainerOfWidget(baseWidget: MdsLax<InstanceType<typeof _WidgetBase>>, maxLevels?: number): MdsLax<InstanceType<typeof TabContainer>> {
        if (maxLevels == null || maxLevels < 1 || !maxLevels) maxLevels = 9999;

        try {
            let parent = baseWidget.getParent()/* as dijit._Widget*/;

            if (!parent) return null;

            maxLevels--;

            if (parent["declaredClass"] == "TabContainer" && parent["containerClasp"]) {
                return parent as MdsLax<InstanceType<typeof TabContainer>>;
            } else {
                if (maxLevels == 0) return null;
                else if (parent["declaredClass"] == "GenericDialog") {
                    // falls das Ding in einem GenericDlg liegt, kann es nicht getabbed sein
                    return null;
                }

                return this._getParentTabContainerOfWidget(parent, maxLevels - 1);
            }
        } catch (ex) {
            return null;
        }
    }

    isTabExisting(tabname: string, containername?: string, activateIfAvailable?: boolean): boolean {
        let result = this.getExistingTab(tabname, containername, activateIfAvailable);

        return result != null;
    }
    getExistingTab(tabname: string, containername?: string, activateIfAvailable?: boolean): Tabbing.TabContainerPage {

        let firstFoundTab = null;
        let containers: Array<MdsLax<InstanceType<typeof TabContainer>>> = [];

        if (containername) {
            let container = this.getTabContainerByName(containername);
            if (!container) return null;

            containers = [container];
        } else {
            containers = this.getTabContainers();
        }
        
        for (let container of containers) {
            let tab = container.getTabByName(tabname);
            if (!firstFoundTab) firstFoundTab = tab;

            if (tab && activateIfAvailable === true) container.switchToTab(tabname);
        }

        return firstFoundTab;
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);        

    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(TabManager);